import IconArrowLeft from "@mui/icons-material/ArrowLeft";
import { UiButtonBase } from "@smp/ui";
import { testAppendAttr, urlTop } from "@smp/utils";
import { useLocation, useNavigate } from "react-router-dom";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";

import { useStyles } from "./button_back.css";
import { IButtonBackProps } from "./button_back.types";

export const ButtonBack = ({ to }: IButtonBackProps) => {
  const location = useLocation();

  const navigate = useNavigate();

  const classes = useStyles();

  const additionalProps =
    typeof to === "function"
      ? {
          onClick: to,
        }
      : to === "back"
      ? {
          onClick: () => navigate(-1),
        }
      : to === "up"
      ? {
          component: HelperAdapterLink,
          to: urlTop(location.pathname),
        }
      : {
          component: HelperAdapterLink,
          to,
        };

  return (
    <UiButtonBase
      {...testAppendAttr("class", `back_button`)}
      {...additionalProps}
      className={classes.button_back}
      color="primary"
    >
      <IconArrowLeft fontSize="large" color="primary" />
    </UiButtonBase>
  );
};
